const getBaseUrl = () => {
  const baseUrl = document.getElementsByTagName('body')[0]?.dataset.baseUrl;
  if (!baseUrl) throw new Error('Could not get base URL');

  return baseUrl;
};

const getPortalUrl = () => {
  const portalUrl = document.getElementsByTagName('body')[0]?.dataset.portalUrl;
  if (!portalUrl) throw new Error('Could not get portal URL');

  return portalUrl;
};

const getViewUrl = () => {
  const viewUrl = document.getElementsByTagName('body')[0]?.dataset.viewUrl;
  if (!viewUrl) throw new Error('Could not get view URL');

  return viewUrl;
};

const getDomain = () => {
  const portalUrl = document.getElementsByTagName('body')[0]?.dataset.portalUrl;
  if (!portalUrl) return;

  const parsedUrl = new URL(portalUrl);
  return parsedUrl.origin;
};

export const url = {
  getBaseUrl,
  getPortalUrl,
  getViewUrl,
  getDomain,
};
